
const getters = {
  trailers: (state) => state.trailers
}
export default getters

// trailerSettings
// fetchTrailerSettings
